enum DashboardCreationOrigin {
	DRIVER = 'DRIVER',
	ALERT = 'ALERT',
	MOBILE = 'MOBILE',
	INTERACTION_PAGE = 'INTERACTION_PAGE'
}

export default DashboardCreationOrigin;
